import React, { useState, useEffect } from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Banner from '../../../components/Banner';
import Reaction from '../../../components/Reaction';
import DetailExpiredMall1 from '../../../local-assets/faq-detail/expired-stamp-mall-v1.png';
import DetailExpiredMall2 from '../../../local-assets/faq-detail/expired-stamp-mall-v2.png';
import DetailExpiredHome from '../../../local-assets/faq-detail/expired-stamp-home.png';
import LastUpdate from '../../../components/LastUpdate';

import Contact from '../../../components/Contact';

const Index = () => {
  const [tabType, setTabType] = useState("mall");
  
  const onChangeTab = (tType) => {
    setTabType(tType);
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

    return (
      <div className="bg-white min-h-screen  flex flex-col">
        <Navbar />
        <Banner
            image={process.env.REACT_APP_S3 + "banner_faq.png"} 
            beforePage="FAQ"
            currentPage="Detail FAQ" 
        />
        <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
            <div className="rounded-2xl md:rounded-3xl">
                <div className="mb-10 md:mb-16 max-w-4xl">
                    <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                        Bagaimana cara mengetahui tanggal kedaluwarsa stamp saya ?
                    </h1>
                </div>
                <div
                  style={{
                    background: "#F2F4F7",
                    borderRadius: 8,
                    padding: 4,
                    display: "inline-flex",
                    marginBottom: 40
                  }}
                >
                  <button 
                    onClick={(e) => onChangeTab("mall")}  
                    className="btn" 
                    type="button"
                    style={{...BtnListStyle.main, ...BtnListStyle[`${tabType === "mall" ? "active" : "inactive"}`]}}
                  >  
                    Summarecon Mall Apps
                  </button>
                  <button 
                    onClick={(e) => onChangeTab("home")}  
                    className="btn" 
                    type="button"
                    style={{...BtnListStyle.main, ...BtnListStyle[`${tabType === "home" ? "active" : "inactive"}`]}}
                  >  
                    Summarecon Home Apps
                  </button>
                </div>
                {tabType === 'mall' ? (
                <div className="grid grid-cols-1 gap-8">
                  <div className="w-full">
                    <ol className="list-decimal pl-5 mt-4 mb-10">
                      <li className="mb-4">
                         <span className="font-bold text-[#101828] text-md md:text-md mb-4 block">
                          Cek kadaluarsa Reguler Stamp
                          </span>
                          <span className="mb-4 text-[#475467] text-md md:text-md block">
                            Reguler Stamp kamu akan kadaluarsa setiap akhir periode mall, periode mall terbagi menjadi dua setiap tahun nya. Periode pertama dari bulan Februari sampai bulan Agustus dan periode kedua dari bulan September sampai bulan Januari. Cek kadaluarsa Reguler Stamp kamu dengan step dibawah ini :
                          </span>
                          <ol className="list-decimal pl-5 mt-4 mb-10 text-[#475467] text-md md:text-md">
                            <li>Buka Summarecon Apps kamu</li>
                            <li>Buka tab profil</li>
                            <li>Pilih Reguler Stamp di profile card (seperti pada gambar dibawah)</li>
                            <li>Lihat kadaluarsa stamp di setiap list nya</li>
                          </ol>
                          <img 
                            src={DetailExpiredMall1} 
                            alt="Reguler Stamp Mall" 
                            className="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8" 
                          />
                      </li>
                      <li className="mb-4">
                        <span className="font-bold text-[#101828] text-md md:text-md mb-4 block">
                          Cek kadaluarsa Premium Stamp
                        </span>
                        <span className='mb-4 text-[#475467] text-md md:text-md block'>
                          Premium Stamp memiliki masa berlaku 2 tahun sejak stamp diperoleh dan akan kedaluwarsa pada akhir bulan di tahun ke-2 masa berlakunya. Kamu dapat melihat expired masing masing stamp di history stamp. Cek kadaluarsa Premium Stamp kamu dengan step dibawah ini :
                        </span>
                        <ol className="list-decimal pl-5 mt-4 mb-10 text-[#475467] text-md md:text-md">
                          <li>Buka Summarecon Apps kamu</li>
                          <li>Buka tab profil</li>
                          <li>Pilih Premium Stamp di profile card (seperti pada gambar dibawah)</li>
                          <li>Lihat kadaluarsa stamp di setiap list nya</li>
                        </ol>
                        <img 
                            src={DetailExpiredMall2} 
                            alt="Reguler Stamp Mall" 
                            className="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8" 
                          />
                      </li>
                    </ol>
                  </div>
                </div>
                )
                :
                (
                <div className="grid grid-cols-1 gap-8">
                  <div className="w-full">
                    <ol className="list-decimal pl-5 mt-4 mb-10">
                      <li className="mb-4">
                        <span className="font-bold text-[#101828] text-md md:text-md mb-4 block">
                          Cek kadaluarsa Premium Stamp
                        </span>
                        <span className='mb-4 text-[#475467] text-md md:text-md block'>
                          Premium Stamp memiliki masa berlaku 2 tahun sejak stamp diperoleh dan akan kedaluwarsa pada akhir bulan di tahun ke-2 masa berlakunya. Kamu dapat melihat expired masing masing stamp di history stamp. Cek kadaluarsa Premium Stamp kamu dengan step dibawah ini :
                        </span>
                        <ol className="list-decimal pl-5 mt-4 mb-10 text-[#475467] text-md md:text-md">
                          <li>Buka Summarecon Apps kamu</li>
                          <li>Buka tab profil</li>
                          <li>Pilih Premium Stamp di profile card (seperti pada gambar dibawah)</li>
                          <li>Lihat kadaluarsa stamp di setiap list nya</li>
                        </ol>
                        <img 
                            src={DetailExpiredHome} 
                            alt="Reguler Stamp Mall" 
                            className="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8" 
                          />
                      </li>
                    </ol>
                  </div>
                </div>
                )}
                <LastUpdate/>
            </div>
        </div>
        <Contact />
        <Footer />
      </div>
    );
}

const BtnListStyle = {
  main: { 
    border: 'none',
    fontSize: 14,
    fontWeight: 500,
    padding: '8px 16px',
    borderRadius: 6,
    transition: 'all 0.2s ease-in-out'
  },
  active: {
    backgroundColor: '#F27023',
    color: 'white',
    boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)'
  },
  inactive: {
    backgroundColor: 'transparent',
    color: "#667085"
  }
}

export default Index;